<template>
  <div>
    <label class="col-12">Order Desk</label>
    <div class="input-group col-6 pr-2">
      <div class="input-group-prepend">
        <span class="input-group-text">Key</span>
      </div>
      <input name="api_key" type="text" class="form-control" :value="data.api_key" @change.stop.prevent="store.commit('api_key', $event.target.value)" />
    </div>
    <div class="input-group col-6 pl-2">
      <div class="input-group-prepend">
        <span class="input-group-text">Secret</span>
      </div>
      <input name="api_secret" type="text" class="form-control" :value="data.api_secret" @change.stop.prevent="store.commit('api_secret', $event.target.value)" />
    </div>
    <div class="col-12 mb-3">
      <small>The api key and api secret will be found at Store Settings &rsaquo; API</small>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    storeId() {
      return this.config?.storeId
    },
    data() {
      return this.store.getter('', {})
    }
  },
  props: {
    config: Object
  }
}
</script>
